import dynamic from 'next/dynamic'

// @ts-ignore
export const WysiwygEditor: any = dynamic(() =>
  import('./WysiwygEditor').then((mod) => mod.WysiwygEditor),
  {ssr: false}
)
